(() => {
  const storageKey = 'zilox_attribution';
  const tracked = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'creator'];
  const safe = (value) => String(value || '').slice(0, 300);
  let data = {};
  try {
    data = JSON.parse(sessionStorage.getItem(storageKey) || '{}') || {};
  } catch (error) {
    data = {};
  }

  const params = new URLSearchParams(window.location.search);
  tracked.forEach((key) => {
    const value = params.get(key);
    if (value) data[key] = safe(value);
  });

  if (!data.landing) data.landing = safe(window.location.pathname + window.location.search);
  if (!data.referrer && document.referrer) data.referrer = safe(document.referrer);

  if (!data.utm_source && data.referrer) {
    const referrer = data.referrer.toLowerCase();
    if (referrer.includes('instagram.com')) data.utm_source = 'instagram';
    else if (referrer.includes('facebook.com') || referrer.includes('fb.com')) data.utm_source = 'facebook';
    else if (referrer.includes('tiktok.com')) data.utm_source = 'tiktok';
    else if (referrer.includes('youtube.com') || referrer.includes('youtu.be')) data.utm_source = 'youtube';
  }

  try {
    sessionStorage.setItem(storageKey, JSON.stringify(data));
  } catch (error) {}

  const apply = () => {
    document.querySelectorAll('[data-zx-attribution]').forEach((input) => {
      const key = input.getAttribute('data-zx-attribution');
      if (key && data[key]) input.value = data[key];
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', apply);
})();